<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-resources`]" width="1em" height="1em" v-bind="$attrs"><path d="M7.49969 11.25L9.99969 8.75L12.4997 11.25V6.875H17.1872C17.5324 6.875 17.8122 7.15482 17.8122 7.5V15.625C17.8122 17.0057 16.6929 18.125 15.3122 18.125H4.68719C3.3066 18.1249 2.18719 17.0056 2.18719 15.625V7.5C2.1872 7.1549 2.46713 6.87513 2.81219 6.875H7.49969V11.25ZM16.8747 1.875C17.7376 1.87502 18.4372 2.57457 18.4372 3.4375C18.4372 4.30043 17.7376 4.99998 16.8747 5H3.12469C2.26175 5 1.56219 4.30044 1.56219 3.4375C1.56219 2.57456 2.26175 1.875 3.12469 1.875H16.8747Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillResources',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
